
import React from 'react';
import { LiveSessionContentProps } from './LiveSessionContentProps';
import MainContentArea from './content/MainContentArea';
import LiveSessionSidebar from './LiveSessionSidebar';

const LiveSessionContent: React.FC<LiveSessionContentProps> = ({
  isMobile,
  showSidebar,
  setShowSidebar,
  isMicActive,
  isVideoActive,
  isAudioActive,
  isScreenSharing,
  screenStream,
  onToggleMic,
  onToggleVideo,
  onToggleAudio,
  onShareScreen,
  onLeaveSession,
  isRecording,
  onToggleRecording,
  recordings,
  onDownloadRecording,
  onClearRecordings,
  onDeleteRecording,
  session,
  elapsedTime,
  audioLevel,
  systemAudioStream,
  onSystemAudioStreamChange,
  sessionId,
  userId,
  displayName
}) => {
  return (
    <div className="flex h-full w-full overflow-hidden">
      {/* Main content area - always visible but may be partially covered by sidebar on mobile */}
      <div className="flex-1 flex h-full overflow-auto">
        <MainContentArea
          isMicActive={isMicActive}
          isVideoActive={isVideoActive}
          isAudioActive={isAudioActive}
          isScreenSharing={isScreenSharing}
          screenStream={screenStream}
          onToggleMic={onToggleMic}
          onToggleVideo={onToggleVideo}
          onToggleAudio={onToggleAudio}
          onShareScreen={onShareScreen}
          onLeaveSession={onLeaveSession}
          isRecording={isRecording}
          onToggleRecording={onToggleRecording}
          onSystemAudioStreamChange={onSystemAudioStreamChange}
          systemAudioStream={systemAudioStream}
          sessionId={sessionId}
          userId={userId}
          displayName={displayName}
        />
      </div>
      
      {/* Sidebar - full screen overlay on mobile with higher z-index */}
      {showSidebar && (
        <div 
          className={`
            ${isMobile ? 'fixed inset-0 z-50 w-full' : 'w-80'} 
            h-full flex flex-col bg-[#1A1F2C] overflow-auto border-l border-[#403E43]/40
            ${isMobile ? 'animate-in slide-in-from-right duration-300' : ''}
          `}
        >
          <LiveSessionSidebar
            visible={showSidebar}
            onClose={() => setShowSidebar(false)}
            isMobile={isMobile}
            sessionFiles={session.files || []}
            sessionName={session.name}
            isRecording={isRecording}
            onToggleRecording={onToggleRecording}
            recordings={recordings}
            onDownloadRecording={onDownloadRecording}
            onClearRecordings={onClearRecordings}
            onDeleteRecording={onDeleteRecording} // Pass it to LiveSessionSidebar
            elapsedTime={elapsedTime}
            session={session}
            audioLevel={audioLevel}
          />
        </div>
      )}
    </div>
  );
};

export default LiveSessionContent;
